import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../components/template/authorization/Authorization";
import AppRoutePath from "../../../../router/AppRoutePath";
import { Link } from "react-router-dom";

export const initFilterInput = {
  searchName: "",
  jabatan: null,
  outlet: null,
  sortBy: "",
  orderBy: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleDelete, handleDetail) => {
  return [
    {
      dataIndex: "id",
      key: "id",
      title: "ID Pegawai",
    },
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Pegawai",
      sorter: true,
      backend_key: "first_name",
      render: (text, record) => (
        <div
          onClick={() => handleDetail(record)}
          style={{
            textTransform: "capitalize",
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "email",
      key: "email",
      title: "Email",
    },
    {
      dataIndex: "phone",
      key: "phone",
      title: "No. Telepon",
    },
    {
      dataIndex: "joinDate",
      key: "joinDate",
      title: "Mulai Masuk",
      sorter: true,
      backend_key: "joined_at",
    },
    {
      dataIndex: "outlet",
      key: "outlet",
      title: "Cabang",
    },
    {
      dataIndex: "jabatan",
      key: "jabatan",
      title: "Jabatan",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="col-1 d-flex justify-content-center flex-row">
          <div className="mr-2">
            <CanAccess
              role={AuthorizationList.update_employee}
              yes={
                <Link
                  to={{
                    pathname: AppRoutePath.USERS_EDIT_EMPLOYEE.replace(
                      ":id",
                      record.id
                    ),
                  }}
                >
                  <BiEditAlt
                    style={{
                      fontSize: 24,
                      color: "#F5CB58",
                      cursor: "pointer",
                    }}
                  />
                </Link>
              }
            />
          </div>

          <CanAccess
            role={AuthorizationList.delete_employee}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
